const de: Record<string, string> = {
  "Virtual Try-On": "Virtuelle Anprobe",
  "Find Your Size & See It On You": "Finden Sie Ihre Größe und probieren Sie es an",
  "See Your Fit": "Ihre Passform ansehen",
  "Check your size, then try it on virtually": "Prüfen Sie Ihre Größe und probieren Sie es virtuell an",
  "Get Your Size": "Ihre Größe",
  "Instant fit suggestion": "Sofortiger Passformvorschlag",
  "Try It On": "Anprobieren",
  "See how it looks on you": "Sehen Sie, wie es Ihnen steht",
  "Find My Size": "Meine Größe finden",
  "Takes less than a minute": "Dauert weniger als eine Minute",
  "Upload a full body photo": "Laden Sie ein Ganzkörperfoto hoch",
  "JPEG, PNG or WebP (max 10MB)": "JPEG, PNG oder WebP (max. 10 MB)",
  "Your photo": "Ihr Foto",
  "Let's find your best fit": "Finden wir Ihre beste Passform",
  "Centimeters": "Zentimeter",
  "Inches": "Zoll",
  "Load saved profile...": "Gespeichertes Profil laden...",
  "HEIGHT": "GRÖSSE",
  "WEIGHT": "GEWICHT",
  "feet": "Fuß",
  "inches": "Zoll",
  "cm": "cm",
  "kg": "kg",
  "lbs": "Pfund",
  "in": "Zoll",
  "How to measure": "So messen Sie",
  "Hide guide": "Anleitung ausblenden",
  "I know my measurements": "Ich kenne meine Maße",
  "Not sure? Use height & weight instead": "Unsicher? Verwenden Sie Größe und Gewicht",
  "Please fill in height and weight": "Bitte Größe und Gewicht eingeben",
  "Please fill in all required fields": "Bitte alle Pflichtfelder ausfüllen",
  "Next": "Weiter",
  "Analyzing your size...": "Ihre Größe wird analysiert...",
  "SUGGESTED SIZE": "VORGESCHLAGENE GRÖSSE",
  "NOT SUGGESTED": "NICHT VORGESCHLAGEN",
  "Edit measurements": "Maße bearbeiten",
  "Size guide": "Größentabelle",
  "Your fit": "Ihre Passform",
  "Your Suggested Size": "Ihre vorgeschlagene Größe",
  "Your measure": "Ihr Maß",
  "within range": "im Bereich",
  "too tight": "zu eng",
  "tight": "eng",
  "a bit tight": "etwas eng",
  "too loose": "zu weit",
  "loose": "weit",
  "a bit loose": "etwas weit",
  "See fit on your photo": "Passform auf Ihrem Foto sehen",
  "Hide visual fit": "Passformanzeige ausblenden",
  "Analyzing...": "Analyse...",
  "Try it on": "Anprobieren",
  "SIZE CHART": "GRÖSSENTABELLE",
  "YOUR ESTIMATED MEASUREMENTS": "IHRE GESCHÄTZTEN MASSE",
  "Edit": "Bearbeiten",
  "Download": "Herunterladen",
  "Size chart": "Größentabelle",
  "Preparing your image...": "Ihr Bild wird vorbereitet...",
  "Analyzing body proportions...": "Körperproportionen werden analysiert...",
  "Matching garment to your photo...": "Kleidungsstück wird an Ihr Foto angepasst...",
  "Generating virtual try-on...": "Virtuelle Anprobe wird erstellt...",
  "Refining details...": "Details werden verfeinert...",
  "Almost there...": "Fast fertig...",
  "Complete!": "Fertig!",
  "This usually takes 15-25 seconds": "Dies dauert normalerweise 15–25 Sekunden",
  "Something went wrong": "Etwas ist schiefgelaufen",
  "Try Again": "Erneut versuchen",
  "We couldn't find a matching size for you": "Wir konnten keine passende Größe für Sie finden",
  "Please try the manual measurement screen so we can calculate your fit from your measurements.": "Bitte nutzen Sie die manuelle Messansicht, damit wir Ihre Passform anhand Ihrer Maße berechnen können.",
  "Try manual measurements": "Manuelle Maße eingeben",
  "SDK not configured. Please provide an API key.": "SDK nicht konfiguriert. Bitte geben Sie einen API-Schlüssel an.",
  "Please upload a JPEG, PNG, or WebP image.": "Bitte laden Sie ein JPEG-, PNG- oder WebP-Bild hoch.",
  "Image must be under 10MB.": "Das Bild muss kleiner als 10 MB sein.",
  "Try-on generation failed": "Anprobe-Erstellung fehlgeschlagen",
  "Failed to start try-on": "Anprobe konnte nicht gestartet werden",
  "No product image found. Please set the product-image attribute.": "Kein Produktbild gefunden. Bitte setzen Sie das product-image Attribut.",
  "Powered by": "Unterstützt von",
  "My Profiles": "Meine Profile",
  "History": "Verlauf",
  "No saved profiles yet.": "Noch keine gespeicherten Profile.",
  "No history yet.": "Noch kein Verlauf.",
  "Product": "Produkt",
  "Women's": "Damen",
  "Men's": "Herren",
  "Profiles": "Profile",
  "Women's Profile": "Damenprofil",
  "Men's Profile": "Herrenprofil",
  "Height": "Größe",
  "Weight": "Gewicht",
  "Chest": "Brust",
  "Bust": "Oberweite",
  "Waist": "Taille",
  "Hips": "Hüfte",
  "Shoulders": "Schultern",
  "Sleeve": "Ärmel",
  "Inseam": "Schrittlänge",
  "Neck": "Hals",
  "Foot": "Fuß",
  "Shoe EU": "Schuh EU",
  "Shoe US": "Schuh US",
  "Shoe UK": "Schuh UK",
  "Saved": "Gespeichert",
  "Delete Profile": "Profil löschen",
  "Shoe size (US)": "Schuhgröße (US)",
  "Shoe size (UK)": "Schuhgröße (UK)",
  "Shoe size (EU)": "Schuhgröße (EU)",
  "Generating...": "Wird erstellt...",
  "Foot length": "Fußlänge",
  "Size": "Größe",
  "Try on size": "Größe anprobieren",
  "e.g.": "z.B.",
  "Drop your photo here or click to upload": "Foto hier ablegen oder klicken zum Hochladen",
  "This usually takes 15-20 seconds": "Dies dauert normalerweise 15–20 Sekunden",
  "Try-on result": "Anprobe-Ergebnis",
  "Try Another": "Andere probieren",
  "Back": "Zurück",
  "You": "Du",
  "Garment": "Kleidung",
  "Your Height": "Deine Größe",
  "Your Weight": "Dein Gewicht",
  "Drag or scroll to set your height": "Ziehen oder scrollen Sie, um Ihre Größe einzustellen",
  "Drag or scroll to set your weight": "Ziehen oder scrollen Sie, um Ihr Gewicht einzustellen",
  "Enter height and weight first": "Geben Sie zuerst Größe und Gewicht ein",

  // ── Field labels ──
  "Lens Width": "Glasbreite",
  "Bridge": "Steg",
  "Arm Length": "Bügellänge",
  "Head Circumference": "Kopfumfang",
  "Face Width": "Gesichtsbreite",
  "Temple": "Bügel",
  "Around widest point": "Um die breiteste Stelle",
  "Foot Length": "Fußlänge",
  "Shoulder": "Schulter",
  "Thigh": "Oberschenkel",
  "Hip": "Hüfte",

  // ── Units ──
  "Millimetre": "Millimeter",
  "Centimetre": "Zentimeter",
  "Millimeters": "Millimeter",

  // ── Fit descriptors ──
  "Tight": "Eng",
  "Loose": "Locker",
  "Short": "Kurz",
  "Long": "Lang",
  "✓ Fit": "✓ Passt",
  "too short": "zu kurz",
  "too long": "zu lang",
  "a bit short": "etwas kurz",
  "a bit long": "etwas lang",

  // ── Length pills ──
  "Length": "Länge",
  "Length Adjustment": "Längenanpassung",
  "Regular": "Regulär",
  "Big": "Groß",
  "Big & Tall": "Groß & Lang",

  // ── Misc ──
  "preview": "Vorschau",

  // ── BodyProfileView — photo upload area (left section) ──
  "Upload your photo": "Lade dein Foto hoch",
  "Upload a photo": "Foto hochladen",
  "Click or drag a full-body photo": "Klicke oder ziehe ein Ganzkörperfoto",
  "Or upload a photo for AI sizing": "Oder lade ein Foto für die KI-Größenanalyse hoch",
  "Photo": "Foto",
  "How to take a good photo": "So machst du ein gutes Foto",
  "How to take the best photo": "So machst du das beste Foto",
  "Do": "Tu das",
  "Don't": "Vermeide",
  "Quick Tip": "Schneller Tipp",
  "The simpler your photo is, the more accurate your virtual try-on results will be.": "Je einfacher dein Foto ist, desto genauer sind die Ergebnisse der virtuellen Anprobe.",
  "Choose a plain background (a light wall is ideal)": "Wähle einen schlichten Hintergrund (eine helle Wand ist ideal)",
  "Stand facing the camera with your full body in frame": "Stelle dich mit dem ganzen Körper im Bild zur Kamera",
  "Stand straight and still, arms relaxed by your sides": "Stehe gerade und still, Arme entspannt an den Seiten",
  "Stand with your HEELS against a wall for best accuracy": "Stelle dich mit den FERSEN an eine Wand für beste Genauigkeit",
  "Use natural or even lighting (e.g. near a window)": "Nutze natürliches oder gleichmäßiges Licht (z. B. am Fenster)",
  "Wear fitted, simple clothing (e.g. neutral colors)": "Trage eng anliegende, schlichte Kleidung (z. B. neutrale Farben)",
  "Don't wear loose, baggy, or layered clothing": "Trage keine weite, lockere oder geschichtete Kleidung",
  "Don't sit, pose, or bend your body": "Sitze nicht, posiere nicht und beuge deinen Körper nicht",
  "Don't use strong backlighting": "Vermeide starkes Gegenlicht",
  "Don't take mirror photos or selfies": "Mache keine Spiegelfotos oder Selfies",
  "Don't apply filters, effects, or edits": "Wende keine Filter, Effekte oder Bearbeitungen an",

  // ── Age gate ──
  "Are you 18 or older?": "Bist du 18 Jahre oder älter?",
  "Yes": "Ja",
  "No": "Nein",
  "Please confirm your age": "Bitte bestätige dein Alter",
  "Please confirm that the person in the photo is 18 or older before uploading.": "Bitte bestätige, dass die Person auf dem Foto 18 Jahre oder älter ist, bevor du es hochlädst.",
  "Under 18 — can't process this photo.": "Unter 18 — dieses Foto kann nicht verarbeitet werden.",
  "This photo appears to be of a minor. Please upload a photo of someone 18 or older.": "Dieses Foto scheint eine minderjährige Person zu zeigen. Bitte lade ein Foto einer Person ab 18 Jahren hoch.",
  "Different photo needed": "Anderes Foto erforderlich",
  "Try another photo": "Anderes Foto versuchen",

  // ── Photo step controls ──
  "Continue": "Weiter",
  "Analyze My Size": "Meine Größe analysieren",
  "Analyzing photo…": "Foto wird analysiert…",
  "Details": "Details",
  "Image must be under 10MB": "Das Bild muss kleiner als 10 MB sein",
  "Please upload an image file": "Bitte lade eine Bilddatei hoch",
  "Please upload a photo": "Bitte lade ein Foto hoch",
  "Prefer not to upload a photo?": "Möchtest du kein Foto hochladen?",
  "Enter measurements manually": "Maße manuell eingeben",
  "Legal Notice": "Rechtlicher Hinweis",
  "Your image will be used to generate a virtual try-on preview showing how selected items may look and fit. Images are processed securely and are not stored after generation.": "Dein Bild wird verwendet, um eine virtuelle Anprobe zu erstellen, die zeigt, wie ausgewählte Artikel aussehen und sitzen können. Bilder werden sicher verarbeitet und nach der Erstellung nicht gespeichert.",

  // ── BodyProfileView — form (right section) ──
  "Body details": "Körperdetails",
  "Your body details": "Deine Körperdetails",
  "Body Measurements": "Körpermaße",
  "AGE": "ALTER",
  "years": "Jahre",
  "Enter your height": "Gib deine Größe ein",
  "Enter your weight": "Gib dein Gewicht ein",
  "Enter your bra size": "Gib deine BH-Größe ein",
  "Please enter your height": "Bitte gib deine Größe ein",
  "Please enter your weight": "Bitte gib dein Gewicht ein",
  "Please enter a valid height": "Bitte gib eine gültige Größe ein",
  "Please enter a valid weight": "Bitte gib ein gültiges Gewicht ein",
  "Please enter a valid height (100-250 cm)": "Bitte gib eine gültige Größe ein (100-250 cm)",
  "Please enter a valid weight (30-300 kg)": "Bitte gib ein gültiges Gewicht ein (30-300 kg)",
  "Please select both band and cup size": "Bitte wähle Unterbrustweite und Cup-Größe",
  "Select your bra size": "Wähle deine BH-Größe",
  "BAND": "UNTERBRUST",
  "BAND SIZE": "UNTERBRUSTWEITE",
  "CUP": "CUP",
  "CUP SIZE": "CUP-GRÖSSE",
  "BRA REGION": "BH-REGION",
  "Imperial": "Imperial",
  "Metric": "Metrisch",
  "These calibrate the AI — all required.": "Diese kalibrieren die KI — alle Pflichtangaben.",
  "Using": "Verwendet",
  "start fresh": "neu beginnen",
  "Close": "Schließen",

  // ── Body shape questions ──
  "Which best describes your chest?": "Was beschreibt deine Brust am besten?",
  "WHICH BEST DESCRIBES YOUR CHEST?": "WAS BESCHREIBT DEINE BRUST AM BESTEN?",
  "Which best describes your hips?": "Was beschreibt deine Hüften am besten?",
  "WHICH BEST DESCRIBES YOUR HIPS?": "WAS BESCHREIBT DEINE HÜFTEN AM BESTEN?",
  "Which best describes your midsection?": "Was beschreibt deine Körpermitte am besten?",
  "WHICH BEST DESCRIBES YOUR MIDSECTION?": "WAS BESCHREIBT DEINE KÖRPERMITTE AM BESTEN?",
  "Which best describes your seat?": "Was beschreibt dein Gesäß am besten?",
  "WHICH BEST DESCRIBES YOUR SEAT?": "WAS BESCHREIBT DEIN GESÄSS AM BESTEN?",
  "Average": "Durchschnittlich",
  "Narrow": "Schmal",
  "Broad": "Breit",
  "Curvy": "Kurvig",
  "A slimmer, narrower chest build": "Eine schlankere, schmalere Brustform",
  "A moderate, proportionate chest": "Eine moderate, proportionierte Brust",
  "A wider, more muscular chest": "Eine breitere, muskulösere Brust",
  "A flatter midsection with minimal protrusion": "Eine flachere Körpermitte mit minimaler Wölbung",
  "A moderate, natural midsection shape": "Eine moderate, natürliche Körpermitte",
  "A fuller, more rounded midsection": "Eine vollere, rundere Körpermitte",
  "A flatter backside with less projection": "Ein flacheres Gesäß mit weniger Wölbung",
  "A moderate, natural backside shape": "Ein moderates, natürliches Gesäß",
  "A fuller, more rounded backside": "Ein volleres, runderes Gesäß",

  // ── Photo step — profile photo preload pill ──
  "Loaded from profile": "Aus Profil geladen",
  "Clear": "Löschen",
};
export default de;
